import React, { createContext, useState, useContext, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

// Contexts
import { useAuthInfo } from '@propelauth/react'

const DatabaseContext = createContext(null)

const generateDatabaseConnections = (orgId) => {
    return [
        {
            id: uuidv4(),
            database: 'MongoDB',
            url: 'https://mongodb.com',
            location: ['us-east-1', 'eu-west-1'],
            status: 'Active',
        },
        {
            id: uuidv4(),
            database: 'PostgreSQL',
            url: 'https://postgresql.com',
            location: ['us-east-1', 'us-east-2', 'us-west-1'],
            status: 'Active',
        },
        {
            id: uuidv4(),
            database: 'Redshift',
            url: 'https://redshift.com',
            location: ['us-east-1', 'us-east-2', 'us-west-1', 'eu-west-1'],
            status: 'Connecting',
        },
        {
            id: uuidv4(),
            database: 'Athena',
            url: 'https://athena.com',
            location: ['us-east-1', 'us-east-2', 'eu-west-1'],
            status: 'Inactive',
        },
    ]
}

export function DatabaseProvider({ children }) {
    const [databases, setDatabases] = useState([])
    const orgId = useAuthInfo().orgId

     useEffect(() => {
         setDatabases(generateDatabaseConnections(orgId))
     }, [])

    return (
        <DatabaseContext.Provider value={{ databases, setDatabases }}>
            {children}
        </DatabaseContext.Provider>
    )
}

export function useDatabase() {
    return useContext(DatabaseContext)
}
